// The following list controls which menu buttons are shown to a user type
//
// The userTypes[] array contains a list of all the user types which can see this item
//
// Control can be further refined to utilise the 'enabled' flag which allows environment
// variables to further control the item
//

import React from "react";
import {UserType} from "root/DataFunctions/Constants";

export const menuItemList = [
    {
        keyName: 1,
        text: 'Home',
        url: '/home',
        alt: 'image',
        image: '/app/style/image/home.svg',
        enabled: true,
        userTypes: [UserType.USER_TYPE_DSL, UserType.USER_TYPE_GOVERNOR]
    },
    {
        keyName: 2,
        text: 'My Schools',
        url: '/school',
        alt: 'image',
        image: '/app/style/image/book.svg',
        enabled: true,
        userTypes: [UserType.USER_TYPE_LOCAL_AUTHORITY_MANAGER]
    },
    {
        keyName: 3,
        text: 'Inbox',
        url: '/inbox',
        alt: 'image',
        image: '/app/style/image/admin-inbox.svg',
        enabled: true,
        userTypes: []
    },
    {
        keyName: 4,
        text: 'History',
        url: '/school/current/history',
        alt: 'image',
        image: '/app/style/image/history.svg',
        enabled: true,
        userTypes: [UserType.USER_TYPE_DSL, UserType.USER_TYPE_GOVERNOR]
    },
    {
        keyName: 5,
        text: 'Guidance',
        url: '/guidance',
        alt: 'image',
        image: '/app/style/image/info.svg',
        enabled: true,
        userTypes: [UserType.USER_TYPE_DSL, UserType.USER_TYPE_GOVERNOR, UserType.USER_TYPE_LOCAL_AUTHORITY_MANAGER]
    },
    {
        keyName: 6,
        text: 'Dashboard',
        url: '/dashboard',
        alt: 'image',
        image: '/app/style/image/dashboard.svg',
        enabled: true,
        userTypes: [UserType.USER_TYPE_LOCAL_AUTHORITY_MANAGER]
    },
    {
        keyName: 7,
        text: 'Dashboard',
        url: '/school/current/dashboard',
        alt: 'image',
        image: '/app/style/image/dashboard.svg',
        enabled: true,
        userTypes: [UserType.USER_TYPE_DSL]
    },
    {
        keyName: 8,
        text: 'Documents',
        url: '/school/current/documents',
        alt: 'image',
        image: '/app/style/image/view-pdf.svg',
        enabled: true,
        userTypes: [UserType.USER_TYPE_DSL, UserType.USER_TYPE_GOVERNOR]
    },
    {
        keyName: 9,
        text: 'Reports',
        url: '/reports',
        alt: 'image',
        image: '/app/style/image/view-pdf.svg',
        enabled: true,
        userTypes: [UserType.USER_TYPE_LOCAL_AUTHORITY_MANAGER]
    },
    {
        keyName: 10,
        text: 'System Admin',
        url: '/administration',
        alt: 'image',
        image: '/app/style/image/manage.svg',
        enabled: true,
        userTypes: [UserType.USER_TYPE_LOCAL_AUTHORITY_MANAGER]
    },

];
